import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React, { useState, useEffect, useRef } from 'react'
import configData from '../../temp/config'

const defaultState = false

const BabyRecipeFinder = (props) => {

  const[recipefinderdata, setRecipefinderdata] = useState({
    title:'',
    searchfieldtitle: '',
    toolicon:'',
    brandlogo:''
  })

  const childRef = useRef(null)

  useEffect(() => {
    setRecipefinderdata({
      title: props.fields.title.value,
      searchfieldtitle: props.fields.description.value,
      toolicon:props.fields.topLogo.value.src,
      brandlogo:props.fields.brandLogo.value.src
    })
  },[])

  return (
      <>
        <div className="newheader">
          <img src={`${configData.sitecoreApiHost}${recipefinderdata.brandlogo}`} />
        </div>
        <div className="tool-header tool-header-recipe header-detail">
          <img src={`${configData.sitecoreApiHost}${recipefinderdata.toolicon}`} />
          <h1 className="redText">
              {recipefinderdata.title}
          </h1>
        </div>
        <div className="form-container form-container-babyrecipe" id="findercomp">
          <div className="searchblk">
              <label>
                  {recipefinderdata.searchfieldtitle}                
              </label>            
          </div>          
        </div>
      </>
  );
}

export default BabyRecipeFinder;